import Building01 from "./building-01";
import Building02 from "./building-02";
import Building03 from "./building-03";
import Building04 from "./building-04";
import Building05 from "./building-05";
import Building06 from "./building-06";
import Building07 from "./building-07";
import Building08 from "./building-08";
import GuestHouse from "./guest-house";
import Home01 from "./home-01";
import Home02 from "./home-02";
import Home03 from "./home-03";
import Home04 from "./home-04";
import Home05 from "./home-05";
import Home06 from "./home-06";
import Home07 from "./home-07";
import Home08 from "./home-08";
import Home09 from "./home-09";
import House from "./house";
import House01 from "./house-01";
import House02 from "./house-02";
import House03 from "./house-03";
import House04 from "./house-04";
import House05 from "./house-05";
import HousePlug from "./house-plug";
import HousePlus from "./house-plus";
import HouseSolarPanel from "./house-solar-panel";
import LightHouse from "./lighthouse";
import Warehouse from "./warehouse";

export * from "./building-07";
export * from "./building-08";
export * from "./building-01";
export * from "./building-02";
export * from "./building-03";
export * from "./building-04";
export * from "./building-05";
export * from "./building-06";
export * from "./house";
export * from "./house-plug";
export * from "./house-plus";
export * from "./home-01";
export * from "./home-02";
export * from "./home-03";
export * from "./home-04";
export * from "./home-05";
export * from "./home-06";
export * from "./home-07";
export * from "./home-08";
export * from "./home-09";
export * from "./house-01";
export * from "./house-02";
export * from "./house-03";
export * from "./house-04";
export * from "./house-05";
export * from "./house-solar-panel";
export * from "./warehouse";
export * from "./lighthouse";
export * from "./guest-house";

export const Buildings = {
  Building07,
  Building08,
  Building01,
  Building02,
  Building03,
  Building04,
  Building05,
  Building06,
  House,
  HousePlug,
  HousePlus,
  Home01,
  Home02,
  Home03,
  Home04,
  Home05,
  Home06,
  Home07,
  Home08,
  Home09,
  House01,
  House02,
  House03,
  House04,
  House05,
  HouseSolarPanel,
  Warehouse,
  LightHouse,
  GuestHouse,
};
